const DAY_MS = 24 * 60 * 60 * 1000;

export const getTrialDaysLeft = (expires?: string | number | null): number =>
  expires ? Math.max(0, Math.ceil((Number(expires) - Date.now()) / DAY_MS)) : 0;
